export default "__VITE_ASSET__CP$0fl2C__"